import React from 'react';

const TenantFAQTest = () => {
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>🎉 Tenant FAQ Test Page</h1>
      <p>If you can see this, the routing is working!</p>
      <p>This is a simple test version to verify the route works.</p>
    </div>
  );
};

export default TenantFAQTest;